import React, { Fragment } from 'react'

import { Grid } from '@/components/Grid'
import { Label } from '@/components/Label'
import { TextField } from '@/components/TextField'
import { useTranslation } from 'react-i18next'
import { LanguagesConfig, TranslatedObject } from '@/api/types'

export type LanguagesProps = {
  languages: LanguagesConfig
  object: TranslatedObject
  handleChangeTranslation(key: string, value: string): void
  errorMessage: string
}

export default function Languages({
  languages,
  object,
  handleChangeTranslation,
  errorMessage,
}: LanguagesProps) {
  const { t } = useTranslation()

  return (
    <>
      <Label>{t('ingredientgroup.name')}</Label>
      <Grid columns="1fr 10fr" gap={8}>
        {languages.languages.map((lang) => (
          <Fragment key={`lang_${lang.code}`}>
            <Label className="Languages-languageLabel">{lang.name}</Label>
            <TextField
              isRequired={languages.defaultLanguage === lang.code}
              value={
                languages.defaultLanguage === lang.code
                  ? object.name
                  : object.nameTranslations?.find((t) => t.languageCode === lang.code)?.translation
              }
              errorMessage={errorMessage}
              onChange={(value) => handleChangeTranslation(lang.code, value)}
            />
          </Fragment>
        ))}
      </Grid>
    </>
  )
}
